// /billing/get_billing_list
import {Axios} from '@/axios/axios.js'
//获取列表
export const getBillList = (e) => {
  return Axios({
    url:"/billing/get_billing_list",
    method:'put',
    data:e
  })
}
//提交订单 /billing/billing_approve
export const approveBill = (e) => {
  return Axios({
    url:"/billing/billing_approve",
    method:'put',
    data:e
  })
}
//设置付款方式 /billing/set_payment_method
export const setPayMethod = (e) => {
  return Axios({
    url:"/billing/set_payment_method",
    method:'put',
    data:e
  })
}
//打印 /billing/print_pay_detail_pdf
export const printPdf = (e) => {
  return Axios({
    url:"/billing/print_pay_detail_pdf",
    method:'put',
    data:e
  })
}
//手动完成 /billing/receive_approve
export const receiveApprove = (e) => {
  return Axios({
    url:"/billing/receive_approve",
    method:'put',
    data:e
  })
}
//获取未结账任务 /billing/get_uninvoiced_task
export const unInvoiceTask = (e) => {
  return Axios({
    url:"/billing/get_uninvoiced_task",
    method:'put',
    data:e
  })
}
//组织number获取组织信息 /billing/get_organization_info
export const getOrgInfo = (e) => {
  return Axios({
    url:"/billing/get_organization_info",
    method:'put',
    data:e
  })
}
//手动创建账单 /billing/manual_create_billing
export const manualCreate = (e) => {
  return Axios({
    url:"/billing/manual_create_billing",
    method:'put',
    data:e
  })
}
//获取支付方式  /billing/get_payment_method
export const getPayMethod = (e) => {
  return Axios({
    url:"/billing/get_payment_method",
    method:'put',
    data:e
  })
}
//获取stripe 预售权支付 付款方式id /billing/get_stripe_client_secret
export const getClientSecret = (e) => {
  return Axios({
    url:"/billing/get_stripe_client_secret",
    method:'put',
    data:e
  })
}
//账单支付 /billing/pay_bills
export const payBill = (e) => {
  return Axios({
    url:"/billing/pay_bills",
    method:'put',
    data:e
  })
}
//获取rapdii信息(公司税号等) public_data/get_rapidi_info
export const getRpidiInfo = (e) => {
  return Axios({
    url:"/public_data/get_rapidi_info",
    method:'put',
    data:e
  })
}
// 获取stripe费率 /billing/get_stripe_cost
export const getStripeCost = (e) => {
  return Axios({
    url:"/billing/get_stripe_cost",
    method:'put',
    data:e
  })
}
